import { H5 } from "@sellar-io/components";
import { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

export const ProductCategoryItemV2Setting = ({
  className,
  title,
  children,
}: {
  className?: string;
  title: string;
  children: ReactNode;
}) => {
  return (
    <div className={twMerge("flex justify-between gap-2 p-4", className)}>
      <H5>{title}</H5>
      {children}
    </div>
  );
};
